define('view/controller/booking/details/DetailsInfoView',['require','marionette','view/controller/booking/details/BookingLeaveConfirmationView','lib/view/ModalRegion'],function (require) {

    var Marionette = require('marionette');
    var BookingLeaveConfirmationView = require('view/controller/booking/details/BookingLeaveConfirmationView');
    var ModalRegion = require('lib/view/ModalRegion');

    /**
     * Client info form view
     *
     * @class ClientInfoView
     */
    return Marionette.LayoutView.extend({

        template: '#details_booking_info_view',
        modelEvents: {
			'change:location': 'render',
			'change:service': 'render',
            'change:provider': 'render',
            'change:category': 'render',
            'change:products': 'render'
        },
        
        ui: {
            'confirmLink': '.sb-confirm-leave a'
        },
        events: {
            'click @ui.confirmLink': 'confirmLinkClick'
        },

        /**
         * Initialize view
         */
        initialize: function () {
            this.listenTo(this.getOption('clientTimeZone'), 'sync', this.render);
            
            this._timeCorrectionModel = this.getOption('timeCorrectionModel');
            this.listenTo(this._timeCorrectionModel, 'sync', this.render);
        },

        /**
         * Serialize data to display on view
         *
         * @return Object
         */
        serializeData: function () {
            var timeDiff = this.getOption('clientTimeZone').get('time_diff');
            var timeDiffWarning = false;
            var recurringDiffs = null;

            if (this._timeCorrectionModel.get('client_time_offset') !== null && this._timeCorrectionModel.get('client_time_offset') != timeDiff) {
                timeDiff = this._timeCorrectionModel.get('client_time_offset');
                timeDiffWarning = true;
            }

            if (this._timeCorrectionModel.get('time_diffs') !== null) {
                recurringDiffs = this._timeCorrectionModel.get('time_diffs');

                if (_.some(recurringDiffs, function (diff) { return diff != timeDiff; })) {
                    timeDiffWarning = true;
                }
            }

            var data = _.extend(Marionette.LayoutView.prototype.serializeData.call(this), {
                time_diff: timeDiff,
                time_diff_warning: timeDiffWarning,
                recurring_dates: this.getOption('timeValidateModel').get('dates'),
                recurring_diffs: recurringDiffs
            });
            return data;
        },
        
        confirmLinkClick: function (evt) {
            evt.preventDefault();
            
            var $target = $(evt.currentTarget);
            var link = $target.attr('href');
            
            var region = new ModalRegion();
            var view = new BookingLeaveConfirmationView();
            region.show(view);

            this.listenTo(view, 'confirm', function () {
                window.location = link;
            });
        }

    });

});
